function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * An Input component that pops and filters auto complete options as you type.
 *
 * props:
 * @param options :[{
 *    title: 'option title for display',
 *    value: 'option value' //option value
 * }]
 * @param popperOptions options for the Popper
 * @param onChange called when the value is changed from the pulldown
 * @param inputPlaceholder place holder for the input box
 * @param disabled disable both input & drop down
 * @param className an optional class name applied to the input element
 * @param defaultTitle the default title to display
 * @param spellCheck flag to disable spell checking, defaults to true
 * @param onEnter called when the Enter key is typed in the input element
 *
 */
import React, { Component } from 'react';
import memoize from 'memoizee';
import classNames from 'classnames';
import debounce from 'lodash.debounce';
import { Popper } from "./popper/index.js";
import "./AutoCompleteInput.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DEBOUNCE_DELAY = 100;
var MENU_NAVIGATION_DIRECTION = /*#__PURE__*/function (MENU_NAVIGATION_DIRECTION) {
  MENU_NAVIGATION_DIRECTION["UP"] = "UP";
  MENU_NAVIGATION_DIRECTION["DOWN"] = "DOWN";
  return MENU_NAVIGATION_DIRECTION;
}(MENU_NAVIGATION_DIRECTION || {});
class AutoCompleteInput extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "popper", void 0);
    _defineProperty(this, "cbContainer", void 0);
    _defineProperty(this, "menuContainer", void 0);
    _defineProperty(this, "input", void 0);
    _defineProperty(this, "getCachedFilteredOptions", memoize((options, input) => options.filter(
    // supports partial match
    option => option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0), {
      max: 1000
    }));
    var popperOptions = this.props.popperOptions;
    popperOptions = _objectSpread({
      placement: 'bottom-end',
      modifiers: {
        preventOverflow: {
          enabled: false
        }
      }
    }, popperOptions);
    this.state = {
      title: '',
      filteredOptions: [],
      keyboardOptionIndex: 0,
      menuIsOpen: false,
      inputWidth: 100,
      invalid: false,
      popperOptions
    };
    this.handleMenuKeyDown = this.handleMenuKeyDown.bind(this);
    this.handleMenuBlur = this.handleMenuBlur.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputKeyDown = this.handleInputKeyDown.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.handelInputFocus = this.handelInputFocus.bind(this);
    this.handleInputClick = this.handleInputClick.bind(this);
    this.updateInputValue = debounce(this.updateInputValue, DEBOUNCE_DELAY);
    this.handleOptionClick = this.handleOptionClick.bind(this);
    this.handleMenuOpened = this.handleMenuOpened.bind(this);
    this.handleMenuExited = this.handleMenuExited.bind(this);
    this.popper = /*#__PURE__*/React.createRef();
    this.cbContainer = /*#__PURE__*/React.createRef();
    this.menuContainer = /*#__PURE__*/React.createRef();
    this.input = /*#__PURE__*/React.createRef();
  }
  setInputWidth() {
    if (this.cbContainer.current) {
      this.setState({
        inputWidth: this.cbContainer.current.getBoundingClientRect().width
      });
    }
  }
  // validation needs to be an exact case-sensitve match on value
  getValueAndValidate(title) {
    if (!title) {
      this.setState({
        invalid: false
      });
      return {
        value: title,
        isValid: false
      };
    }

    // validate
    var options = this.props.options;
    var result = options.filter(option => option.title.toLowerCase() === title.toLowerCase());
    if (result.length < 1) {
      this.setState({
        invalid: true
      });
      return {
        value: title,
        isValid: false
      };
    }
    this.setState({
      invalid: false
    });
    return {
      value: result[0].value,
      isValid: true
    };
  }

  // validate typed entries emit change event using value
  updateInputValue(title) {
    var menuIsOpen = this.state.menuIsOpen;
    var _this$getValueAndVali = this.getValueAndValidate(title),
      value = _this$getValueAndVali.value,
      isValid = _this$getValueAndVali.isValid;
    if (menuIsOpen) this.processFilterChange(title);
    this.fireOnChange(value, isValid);
  }
  fireOnChange(value) {
    var isValid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var onChange = this.props.onChange;
    onChange(value, isValid);
  }
  processFilterChange(filter) {
    var _this$popper$current;
    var options = this.props.options;
    var menuIsOpen = this.state.menuIsOpen;
    var filteredOptions = filter ? this.getCachedFilteredOptions(options, filter) : options;
    var perfectMatch = filteredOptions.length === 1 && filteredOptions[0].title === filter;
    this.setState({
      filteredOptions,
      keyboardOptionIndex: 0
    });
    if (perfectMatch && menuIsOpen) {
      this.closeMenu();
      return;
    }
    (_this$popper$current = this.popper.current) === null || _this$popper$current === void 0 || _this$popper$current.scheduleUpdate(); // filtered options list can change size, may need to be repositioned
  }
  resetValue() {
    this.setState({
      title: ''
    });
    this.fireOnChange('');
  }
  handleResize() {
    this.setInputWidth();
  }
  handleMenuKeyDown(event) {
    var _this$input$current;
    var _this$state = this.state,
      filteredOptions = _this$state.filteredOptions,
      keyboardOptionIndex = _this$state.keyboardOptionIndex;
    var option = filteredOptions[keyboardOptionIndex];
    switch (event.key) {
      case 'Enter':
      case 'ArrowRight':
        event.stopPropagation();
        event.preventDefault();
        if (option != null) {
          this.setState({
            title: option.title,
            invalid: false
          });
          this.fireOnChange(option.value);
        }
        this.closeMenu();
        (_this$input$current = this.input.current) === null || _this$input$current === void 0 || _this$input$current.focus();
        break;
      case 'ArrowUp':
        event.stopPropagation();
        event.preventDefault();
        this.navigateMenu(AutoCompleteInput.MENU_NAVIGATION_DIRECTION.UP);
        break;
      case 'ArrowDown':
        event.stopPropagation();
        event.preventDefault();
        this.navigateMenu(AutoCompleteInput.MENU_NAVIGATION_DIRECTION.DOWN);
        break;
      case 'Tab':
        event.stopPropagation();
        event.preventDefault();
        if (event.shiftKey) {
          this.navigateMenu(AutoCompleteInput.MENU_NAVIGATION_DIRECTION.UP);
          break;
        }
        this.navigateMenu(AutoCompleteInput.MENU_NAVIGATION_DIRECTION.DOWN);
        break;
      case 'Escape':
        event.preventDefault();
        event.stopPropagation();
        this.closeMenu();
        break;
      default:
        break;
    }
  }
  navigateMenu(direction) {
    var _this$state2 = this.state,
      filteredOptions = _this$state2.filteredOptions,
      keyboardOptionIndex = _this$state2.keyboardOptionIndex;
    var newKeyboardOptionIndex = keyboardOptionIndex;
    if (direction === AutoCompleteInput.MENU_NAVIGATION_DIRECTION.UP) {
      if (keyboardOptionIndex > 0) {
        newKeyboardOptionIndex = (newKeyboardOptionIndex - 1) % filteredOptions.length;
        this.setState({
          keyboardOptionIndex: newKeyboardOptionIndex
        });
      } else if (keyboardOptionIndex === 0) {
        newKeyboardOptionIndex = filteredOptions.length - 1;
        this.setState({
          keyboardOptionIndex: newKeyboardOptionIndex
        });
      }
    } else if (direction === AutoCompleteInput.MENU_NAVIGATION_DIRECTION.DOWN) {
      if (keyboardOptionIndex < filteredOptions.length) {
        newKeyboardOptionIndex = (newKeyboardOptionIndex + 1) % filteredOptions.length;
        this.setState({
          keyboardOptionIndex: newKeyboardOptionIndex
        });
      }
    }
    this.scrollOptionIntoView(newKeyboardOptionIndex);
  }
  handleInputKeyDown(event) {
    var onEnter = this.props.onEnter;
    var menuIsOpen = this.state.menuIsOpen;
    if (menuIsOpen) {
      this.handleMenuKeyDown(event);
    } else if (event.key === 'Enter') {
      onEnter();
    } else if (event.key === 'Escape') {
      this.resetValue();
      event.preventDefault();
      event.stopPropagation();
    } else if (!(event.key === 'ArrowRight' || event.key === 'ArrowLeft' || event.key === 'Tab' || event.key === 'Shift')) {
      this.openMenu();
    }
  }
  handleInputChange(event) {
    this.setState({
      title: event.target.value
    });
    this.updateInputValue(event.target.value);
  }
  handleOptionClick(option) {
    var _this$input$current2;
    this.setState({
      title: option.title,
      invalid: false
    });
    this.fireOnChange(option.value);
    this.closeMenu();
    (_this$input$current2 = this.input.current) === null || _this$input$current2 === void 0 || _this$input$current2.focus();
  }
  handelInputFocus() {
    var menuIsOpen = this.state.menuIsOpen;
    if (!menuIsOpen) {
      this.openMenu();
    }
  }
  handleInputClick() {
    var menuIsOpen = this.state.menuIsOpen;
    if (!menuIsOpen) {
      this.openMenu();
    }
  }
  handleInputBlur(event) {
    var menuIsOpen = this.state.menuIsOpen;
    if (menuIsOpen && event.relatedTarget instanceof Element && this.popper.current !== null && this.popper.current.element.contains(event.relatedTarget)) {
      return;
    }
    this.closeMenu(false);
  }
  handleMenuBlur(event) {
    // if blur event is caused by focusing on the input or focus on options don't close menu
    if (event.relatedTarget === this.input.current || event.relatedTarget instanceof Element && this.popper.current !== null && this.popper.current.element.contains(event.relatedTarget)) {
      return;
    }
    this.closeMenu(false);
  }
  handleMenuOpened() {
    var _this$input$current3;
    (_this$input$current3 = this.input.current) === null || _this$input$current3 === void 0 || _this$input$current3.focus();
  }
  handleMenuExited() {
    var menuIsOpen = this.state.menuIsOpen;
    if (menuIsOpen) {
      this.setState({
        menuIsOpen: false,
        keyboardOptionIndex: 0
      });
    }
  }
  openMenu() {
    var title = this.state.title;
    this.processFilterChange(title);
    this.setInputWidth();
    this.setState({
      menuIsOpen: true
    });

    // https://github.com/reactjs/react-transition-group/issues/382
    window.requestAnimationFrame(() => {
      var _this$popper$current2;
      (_this$popper$current2 = this.popper.current) === null || _this$popper$current2 === void 0 || _this$popper$current2.show();
    });
  }
  closeMenu() {
    var _this$popper$current3;
    var focusInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this.setState({
      menuIsOpen: false,
      keyboardOptionIndex: 0
    });
    if (focusInput) {
      var _this$input$current4;
      (_this$input$current4 = this.input.current) === null || _this$input$current4 === void 0 || _this$input$current4.focus();
    }
    (_this$popper$current3 = this.popper.current) === null || _this$popper$current3 === void 0 || _this$popper$current3.hide();
  }
  scrollOptionIntoView(index) {
    if (this.menuContainer.current) {
      var _this$menuContainer$c;
      (_this$menuContainer$c = this.menuContainer.current.children.item(index)) === null || _this$menuContainer$c === void 0 || _this$menuContainer$c.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }
  renderMenuElement() {
    var inputWidth = this.state.inputWidth;
    return /*#__PURE__*/_jsx("div", {
      className: classNames('aci-options'),
      ref: this.menuContainer,
      role: "presentation",
      onKeyDown: this.handleMenuKeyDown,
      style: {
        width: inputWidth
      },
      onBlur: this.handleMenuBlur,
      children: this.renderOptions()
    });
  }
  renderOptions() {
    var noMatchText = this.props.noMatchText;
    var _this$state3 = this.state,
      title = _this$state3.title,
      filteredOptions = _this$state3.filteredOptions;
    if (title && filteredOptions.length === 0) {
      return /*#__PURE__*/_jsx("div", {
        className: "no-match",
        children: noMatchText
      });
    }
    return filteredOptions.map((option, index) => this.renderOption(option, index));
  }
  renderOption(option, index) {
    var keyboardOptionIndex = this.state.keyboardOptionIndex;
    var key = "option-".concat(index, "-").concat(option.value);
    return /*#__PURE__*/_jsx("button", {
      type: "button",
      className: classNames('aci-option-btn', {
        'keyboard-active': keyboardOptionIndex === index
      }),
      onClick: () => this.handleOptionClick(option),
      onFocus: () => this.setState({
        keyboardOptionIndex: index
      }),
      children: option.title
    }, key);
  }
  render() {
    var _this$props = this.props,
      options = _this$props.options,
      inputPlaceholder = _this$props.inputPlaceholder,
      disabled = _this$props.disabled,
      className = _this$props.className,
      defaultTitle = _this$props.defaultTitle,
      spellCheck = _this$props.spellCheck,
      dataTestId = _this$props['data-testid'];
    var _this$state4 = this.state,
      title = _this$state4.title,
      menuIsOpen = _this$state4.menuIsOpen,
      popperOptions = _this$state4.popperOptions,
      invalid = _this$state4.invalid;
    return /*#__PURE__*/_jsxs("div", {
      className: "aci-container",
      ref: this.cbContainer,
      children: [/*#__PURE__*/_jsx("input", {
        value: title || defaultTitle,
        className: classNames('form-control', className, 'aci-input', {
          'is-invalid': invalid && !menuIsOpen
        }),
        ref: this.input,
        onChange: this.handleInputChange,
        placeholder: inputPlaceholder || options[0].title,
        disabled: disabled,
        onFocus: this.handelInputFocus,
        onClick: this.handleInputClick,
        onBlur: this.handleInputBlur,
        onKeyDown: this.handleInputKeyDown,
        spellCheck: spellCheck,
        "data-testid": dataTestId
      }), /*#__PURE__*/_jsx(Popper, {
        ref: this.popper,
        options: popperOptions,
        className: classNames('aci-options-popper interactive'),
        onEntered: this.handleMenuOpened,
        onExited: this.handleMenuExited,
        children: this.renderMenuElement()
      })]
    });
  }
}
_defineProperty(AutoCompleteInput, "defaultProps", {
  onChange() {
    // no-op
  },
  inputPlaceholder: '',
  disabled: false,
  className: '',
  defaultTitle: '',
  popperOptions: null,
  spellCheck: true,
  onEnter() {
    // no-op
  },
  noMatchText: 'No matching items found',
  'data-testid': undefined
});
_defineProperty(AutoCompleteInput, "MENU_NAVIGATION_DIRECTION", MENU_NAVIGATION_DIRECTION);
export default AutoCompleteInput;
//# sourceMappingURL=AutoCompleteInput.js.map